import React from 'react';
import Card from '../../../../component/Card';
import Form from '../../../../component/Form';
import Table from '../../../../component/Table';

const View = ({ row, penilaianResult, values, handleChange, handleSubmit }) => {
  return (
    <>
      <div className='container-fluid '>
        <div className='row justify-content-center'>
          <div className='col-lg-12'>
            <Card marginTop={ 2 }>
              <Card.Body>
                <h2>Penilaian Pemeriksaan Jasa Boga </h2>
                {penilaianResult.data ? (
                  <>
                    <h3>Hasil Penilaian</h3>
                    <div className='row'>
                      <div className='col-2'>Keterangan</div>
                      <div className='col'>
                        {penilaianResult.data.lulus ? 'LULUS' : 'TIDAK LULUS'}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-2'>Golongan</div>
                      <div className='col'>
                        {penilaianResult.data.masuk_golongan}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-2'>Total Score</div>
                      <div className='col'>
                        {penilaianResult.data.total_score}
                      </div>
                    </div>
                  </>
                ) : (
                  <Table
                    headers={ [
                      'No',
                      'Variabel',
                      'Komponen Yang Dinilai',
                      'Bobot',
                      'Nilai',
                    ] }
                    data={ row }
                    columnMapper={ (data) => {
                      return [
                        data[ 0 ],
                        data[ 1 ].map((value) => (
                          <div className='mb-2'>{value.name}</div>
                        )),
                        data[ 1 ].map((value) => (
                          <div className='mb-2'>{value.bobot}</div>
                        )),
                        data[ 1 ].map((value) => (
                          <div className='mb-1'>
                            <input
                              style={ { width: '50px', height: '25px' } }
                              className='form-control form-control-sm'
                              type='number'
                              name={ value.id }
                              onChange={ (e) =>
                                handleChange(e, value.bobot, data[ 0 ])
                              }
                            />
                          </div>
                        )),
                      ];
                    } }
                    isBordered
                    pagination={ false }
                  />
                )}

                <div className='row mt-2'>
                  <div className='col d-flex justify-content-end'>
                    <button className='btn btn-success' onClick={ handleSubmit }>
                      Simpan
                    </button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default View;
